export default "__VITE_ASSET__DdRpKLHm__"